import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import SmartNavigation from '../../components/Navigation/SmartNavigation';
import { images } from '../../components/shared/assets';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { useOverlayManager } from '../../contexts/OverlayContext';
import './GallerySantaCatarina.css';

// Santa Catarina-specific gallery images (using local assets)
const santaCatarinaGalleryImages = [
  { src: '/assets/images/gallery-santa-catarina-landscape.png', alt: 'Santa Catarina Coastline' },
  { src: '/assets/images/destinationsSantaCatarina.png', alt: 'Awasi Santa Catarina Beach Lodge' },
  { src: '/assets/images/packageCollage1.png', alt: 'Beach Vista' },
  { src: '/assets/images/packageCollage2.png', alt: 'Ocean View' },
  { src: '/assets/images/packageCollage3.png', alt: 'Coastal Paradise' },
  { src: '/assets/fullviewportsantacatarina.jpg', alt: 'Awasi Santa Catarina Villa' },
  { src: '/assets/santa-catarina-factsheet-hero.jpg', alt: 'Beach Reflection' },
  { src: '/assets/experiencepagebreak.jpg', alt: 'Santa Catarina Experience' },
  { src: '/assets/images/video1.png', alt: 'Surfing' },
  { src: '/assets/images/video2.png', alt: 'Island Hopping' },
  { src: '/assets/images/video3.png', alt: 'Beach Activities' },
  { src: '/assets/images/video4.png', alt: 'Marine Wildlife' }
];

const GallerySantaCatarina: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

  // Initialize features and clear hover state
  useEffect(() => {
    window.scrollTo(0, 0);
    const cleanup = initializeAllFeatures();
    setHoveredDestination(null);
    return cleanup;
  }, [setHoveredDestination]);

  return (
    <div className="gallery-santa-catarina-page">
      {/* Navigation with light variant for Santa Catarina */}
      <SmartNavigation forceVariant="light" />

      {/* Hero Section */}
      <div 
        className="gallery-hero-section"
        data-scroll-section="hero"
        style={{ 
          backgroundImage: `url('/assets/santa-catarina-factsheet-hero.jpg')`
        }}
      >
        <div className="gallery-hero-overlay">
          <h1 className="gallery-hero-title">Awaken to Unforgettable Views</h1>
          <p className="gallery-hero-subtitle">Take a seat in the front row, watching the theatre of mother nature unfold.</p>
        </div>
      </div>

      {/* Filter Bar */}
      <div className="gallery-filter-bar" data-scroll-section="filters">
        <div className="gallery-filters">
          <button 
            className={`filter-button ${selectedFilter === 'santa-catarina' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'santa-catarina' ? null : 'santa-catarina')}
          >
            SANTA CATARINA +
          </button>
          <button 
            className={`filter-button ${selectedFilter === 'type' ? 'active' : ''}`}
            onClick={() => setSelectedFilter(selectedFilter === 'type' ? null : 'type')}
          >
            TYPE +
          </button>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="gallery-grid-section" data-scroll-section="gallery-grid">
        <div className="gallery-grid">
          {santaCatarinaGalleryImages.map((image, index) => (
            <div 
              key={index} 
              className={`gallery-item gallery-item--${(index % 4) + 1}`}
              data-scroll-animation="fade-up"
            >
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>

      {/* Instagram Section */}
      <div data-scroll-section="instagram">
        <InstagramSection 
          title="Follow us on Instagram @awasiexperience"
          posts={[
            { src: images.instagram1, alt: "Santa Catarina Instagram 1" },
            { src: images.instagram2, alt: "Santa Catarina Instagram 2", isVideo: true },
            { src: images.instagram3, alt: "Santa Catarina Instagram 3" },
            { src: images.instagram4, alt: "Santa Catarina Instagram 4" }
          ]}
        />
      </div>

      {/* Footer with Santa Catarina variant */}
      <Footer variant="santa-catarina" />
    </div>
  );
};

export default GallerySantaCatarina;